import React from 'react';
import { Button, Drawer } from 'antd';
import ColumnConfigEditor from './ColumnConfigEditor';

/**
 * Column configuration drawer — thin Drawer wrapper around ColumnConfigEditor.
 * Wired to per-user settings via the `useColumnConfig` hook (localStorage-backed).
 */
export default function ColumnConfigDrawer({
  open,
  onClose,
  columns,
  hidden,
  fixedKeys,
  onToggle,
  onMove,
  onReset,
  pageSize,
  onPageSizeChange,
  hidePageSize,
}) {
  return (
    <Drawer
      title="Settings"
      placement="right"
      onClose={onClose}
      open={open}
      width={320}
      zIndex={1010}
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onReset}>Reset to defaults</Button>
        </div>
      }
    >
      <ColumnConfigEditor
        columns={columns}
        hidden={hidden}
        fixedKeys={fixedKeys}
        onToggle={onToggle}
        onMove={onMove}
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
        hidePageSize={hidePageSize}
      />
    </Drawer>
  );
}
